import { useQuery } from "convex/react";
import { useParams } from "react-router-dom";
import { api as convexApi } from "../../convex/_generated/api";
import type { Id } from "../../convex/_generated/dataModel";
import type { AudienceSessionJoinInfo } from "../../shared/types.ts";
import { normalizeJoinCode } from "./join.ts";

export type StaffSessionRoute = {
  hasJoinCodeRoute: boolean;
  requestedJoinCode: string;
  resolving: boolean;
  notFound: boolean;
  joinInfo: AudienceSessionJoinInfo | null | undefined;
  sessionId: Id<"sessions"> | undefined;
  joinCode: string | null;
};

export function useStaffSessionRoute(): StaffSessionRoute {
  const { joinCode: routeJoinCode } = useParams();
  const hasJoinCodeRoute = typeof routeJoinCode === "string";
  const requestedJoinCode = normalizeJoinCode(routeJoinCode);
  const canResolve = hasJoinCodeRoute && requestedJoinCode.length === 6;
  const joinInfo = useQuery(
    convexApi.audience.resolveJoinCode,
    canResolve ? { joinCode: requestedJoinCode } : "skip",
  ) as AudienceSessionJoinInfo | null | undefined;

  return {
    hasJoinCodeRoute,
    requestedJoinCode,
    resolving: canResolve && joinInfo === undefined,
    notFound: hasJoinCodeRoute && (!canResolve || joinInfo === null),
    joinInfo,
    sessionId: joinInfo?.sessionId as Id<"sessions"> | undefined,
    joinCode: joinInfo?.joinCode ?? (canResolve ? requestedJoinCode : null),
  };
}
